// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'


import echarts from 'echarts';
// 引入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import router from './router'

import 'babel-polyfill';
require('es6-promise').polyfill();
import 'fetch-detector';
import 'fetch-ie8';


//Vue.prototype.$host = 'http://localhost:9090', // 本地环境
// Vue.prototype.$host = 'https://op.ideadoit.cn';// 测试环境
// Vue.prototype.$host = 'https://op.xyrehab.com', // 正式环境
Vue.prototype.$host = 'https://boai.xyrehab.com', // 正式环境
// Vue.prototype.$host = 'http://111.8.62.117:9070', // 测试环境

Vue.use(ElementUI, { zhLocale })

Vue.prototype.$echarts = echarts

Vue.use(ElementUI);
Vue.config.productionTip = false







/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js